import { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
let current; // undefined = unknown, null = guest, object = user
let pending = null;
const listeners = new Set();

const emit = (u) => { current = u; listeners.forEach((l) => l(u)); };

export const notifyAuthChange = (user) => emit(user);

export function refreshAuth() {
  if (window.location.hash?.includes('session_id=')) return Promise.resolve(current);
  if (!pending) {
    pending = fetch(`${API_URL}/api/auth/me`, { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null)
      .then((u) => { pending = null; emit(u); return u; });
  }
  return pending;
}

export function startGoogleLogin(path) {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + path;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export async function logoutUser() {
  await fetch(`${API_URL}/api/auth/logout`, { method: 'POST', credentials: 'include' }).catch(() => {});
  emit(null);
}

export function useAuth() {
  const [user, setUser] = useState(current);
  useEffect(() => {
    listeners.add(setUser);
    if (current === undefined) refreshAuth();
    else setUser(current);
    return () => listeners.delete(setUser);
  }, []);
  return { user, loading: user === undefined };
}
